// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header 样式 */

.room-header {
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid var(--crystal-border);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 700;
  font-size: 1.5rem;
  color: var(--gray-800);
  cursor: pointer;
  transition: all var(--duration-normal) ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-text {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.room-info {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.room-id-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.room-label {
  font-size: 0.875rem;
  color: var(--gray-600);
  font-weight: 500;
}

.room-id-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.6);
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  border: 1px solid var(--gray-200);
}

.room-id {
  font-family: 'Monaco', 'Consolas', monospace;
  font-weight: 600;
  color: var(--gray-800);
  font-size: 0.875rem;
  letter-spacing: 0.5px;
}

.copy-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: var(--gray-500);
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--duration-fast) ease;
}

.copy-btn:hover {
  background: var(--gray-200);
  color: var(--gray-700);
  transform: scale(1.1);
}

.user-count {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--gray-600);
  font-weight: 500;
}

.user-count i {
  color: var(--leaf-500);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid var(--crystal-border);
  border-radius: 24px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all var(--duration-normal) ease;
}

.connection-status-connected {
  color: var(--leaf-700);
  border-color: var(--leaf-200);
  background: var(--leaf-50);
}

.connection-status-connecting {
  color: var(--lemon-700);
  border-color: var(--lemon-200);
  background: var(--lemon-50);
}

.connection-status-disconnected {
  color: var(--gray-600);
  border-color: var(--gray-200);
  background: var(--gray-50);
}

.connection-status i {
  font-size: 0.75rem;
}

.connection-status-connected i {
  color: var(--leaf-500);
  animation: pulse 2s infinite;
}

.connection-status-connecting i {
  color: var(--lemon-500);
  animation: pulse 1s infinite;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .room-header {
    padding: 1rem;
  }
  
  .header-content {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .header-left {
    width: 100%;
    justify-content: space-between;
    gap: 1rem;
  }
  
  .room-info {
    gap: 1rem;
  }
  
  .logo {
    font-size: 1.25rem;
  }
  
  .header-right {
    width: 100%;
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .room-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  
  .room-id-section {
    width: 100%;
  }
  
  .room-id-group {
    flex: 1;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;IACP,8BAA8B;EAChC;AACF","sourcesContent":["/* Header 样式 */\n\n.room-header {\n  padding: 1rem 2rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  border-bottom: 1px solid var(--crystal-border);\n}\n\n.header-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 700;\n  font-size: 1.5rem;\n  color: var(--gray-800);\n  cursor: pointer;\n  transition: all var(--duration-normal) ease;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n}\n\n.logo-text {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.room-info {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.room-id-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.room-label {\n  font-size: 0.875rem;\n  color: var(--gray-600);\n  font-weight: 500;\n}\n\n.room-id-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.6);\n  padding: 0.5rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid var(--gray-200);\n}\n\n.room-id {\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-weight: 600;\n  color: var(--gray-800);\n  font-size: 0.875rem;\n  letter-spacing: 0.5px;\n}\n\n.copy-btn {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: var(--gray-500);\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--duration-fast) ease;\n}\n\n.copy-btn:hover {\n  background: var(--gray-200);\n  color: var(--gray-700);\n  transform: scale(1.1);\n}\n\n.user-count {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--gray-600);\n  font-weight: 500;\n}\n\n.user-count i {\n  color: var(--leaf-500);\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.connection-status {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid var(--crystal-border);\n  border-radius: 24px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all var(--duration-normal) ease;\n}\n\n.connection-status-connected {\n  color: var(--leaf-700);\n  border-color: var(--leaf-200);\n  background: var(--leaf-50);\n}\n\n.connection-status-connecting {\n  color: var(--lemon-700);\n  border-color: var(--lemon-200);\n  background: var(--lemon-50);\n}\n\n.connection-status-disconnected {\n  color: var(--gray-600);\n  border-color: var(--gray-200);\n  background: var(--gray-50);\n}\n\n.connection-status i {\n  font-size: 0.75rem;\n}\n\n.connection-status-connected i {\n  color: var(--leaf-500);\n  animation: pulse 2s infinite;\n}\n\n.connection-status-connecting i {\n  color: var(--lemon-500);\n  animation: pulse 1s infinite;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .room-header {\n    padding: 1rem;\n  }\n  \n  .header-content {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n  \n  .header-left {\n    width: 100%;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n  \n  .room-info {\n    gap: 1rem;\n  }\n  \n  .logo {\n    font-size: 1.25rem;\n  }\n  \n  .header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-left {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n  \n  .room-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n    width: 100%;\n  }\n  \n  .room-id-section {\n    width: 100%;\n  }\n  \n  .room-id-group {\n    flex: 1;\n    justify-content: space-between;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
